export const SIDEBAR = 'Sidebar';
export const ORDER_DETAILS_CANVAS = 'OrderDetailsCanvas';
export const SHIPMENT_DETAILS = 'ShipmentDetails';
export const RATE_BROWSER = 'RateBrowser';
export const CUSTOMER_CREATE_LABEL = 'CustomerCreateLabel';
